.controlTable {
    margin-bottom: 10px;
}

.showMoreButton {
    margin-top: 10px;
}